import { Flex, Progress } from "antd";
import { ReactNode } from "react";
import linebg from "assets/svg/lineBg2.svg";
import radialLineBg from "assets/svg/radialLineBg.svg";

const RightSideonboardingContainer = ({
  children,
  isFirstPage,
}: {
  children: ReactNode;
  isFirstPage: boolean;
}) => {
  return (
    <div
      style={{
        backgroundImage: `url(${isFirstPage ? radialLineBg : linebg})`,
        backgroundPosition: "bottom ",
      }}
      className="border bg-no-repeat rounded-lg border-[#EBF1FF] self-start pb-5 bg-white"
    >
      <div className=" ml-8 flex gap-3 items-center py-3">
        <Flex gap="small" wrap>
          <Progress
            strokeColor={`#FF6929`}
            type="circle"
            size={40}
            percent={isFirstPage ? 50 : 100}
            format={() => (
              <span className="font-semibold text-[#333333] text-sm font-grotesk">
                {isFirstPage ? "1" : "2"}/2
              </span>
            )}
          />
        </Flex>
        <p className="font-grotesk font-medium text-lg lg:text-2xl">
          {isFirstPage ? "Personal Profile" : "Preference & Usage"}
        </p>
      </div>
      <hr className="w-[100%] border-b-[#EBF1FF] border-b text-[#EBF1FF]" />
      <div className="ml-8 mr-8  ">
        <p className="mt-5 mb-3 text-base font-medium font-grotesk">
          {!isFirstPage && "How do you plan to use StagePanda?"}
        </p>
        {children}
      </div>
    </div>
  );
};

export default RightSideonboardingContainer;
